import {useCodeViewOptions} from '@github-ui/use-code-view-options'
import {SplitPageLayout} from '@primer/react'
import React from 'react'

import styles from './SharedPageLayout.module.css'

export function SharedPageLayout({
  sidebar,
  children,
  narrow,
  endSidebar,
}: React.PropsWithChildren<{sidebar?: React.ReactNode; narrow: boolean; endSidebar?: React.ReactNode}>) {
  const {codeCenterOption} = useCodeViewOptions()

  return (
    <SplitPageLayout>
      {sidebar}
      <SplitPageLayout.Content
        as="div"
        padding="none"
        width={codeCenterOption.enabled ? 'xlarge' : 'full'}
        hidden={{narrow}}
      >
        {/* tabIndex is required for keyboard focus management in CodeViewLayout's toggleFocus */}
        {/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */}
        <div className={styles.content} data-selector="repos-split-pane-content" tabIndex={0}>
          {children}
        </div>
      </SplitPageLayout.Content>
      {endSidebar}
    </SplitPageLayout>
  )
}
